import zhCn from "element-plus/es/locale/lang/zh-cn";
import zhTw from "element-plus/es/locale/lang/zh-tw";
import en from "element-plus/es/locale/lang/en";
import ja from "element-plus/es/locale/lang/ja";
import vi from "element-plus/es/locale/lang/vi";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import "dayjs/locale/en";
import "dayjs/locale/ja";
import "dayjs/locale/vi";

export function getElementAndDayjsLocaleByI18nLocale(locale: string) {
  const normalizedLocale = (locale || "").toLowerCase();
  if (normalizedLocale === "zh-hant" || normalizedLocale === "zh-tw") {
    return {
      elementLocale: zhTw,
      dayjsLocale: "zh-tw",
    };
  }
  if (normalizedLocale === "ja_jp" || normalizedLocale === "ja") {
    return {
      elementLocale: ja,
      dayjsLocale: "ja",
    };
  }
  if (normalizedLocale === "vi_vn" || normalizedLocale === "vi") {
    return {
      elementLocale: vi,
      dayjsLocale: "vi",
    };
  }
  if (normalizedLocale === "en") {
    return {
      elementLocale: en,
      dayjsLocale: "en",
    };
  }
  return {
    elementLocale: zhCn,
    dayjsLocale: "zh-cn",
  };
}

export function syncDayjsLocale(locale: string) {
  const localeConfig = getElementAndDayjsLocaleByI18nLocale(locale);
  dayjs.locale(localeConfig.dayjsLocale);
  return localeConfig;
}
